module.exports = __webpack_public_path__ + "static/media/tow_logo.dabcf731.svg";